import request from "root/js/request";

export const getParsersKeywords = async ({ keyword_ids__in, keyword_ids, limit, offset }) => {
  const response = await request({
    url: `/parsers/keywords/`,
    method: "get",
    params: {
      keyword_ids__in,
      keyword_ids,
      limit,
      offset,
    },
  });
  return response.data;
};
